<div *ngIf="!getSessionExpired" class="row" mt-5>
  <h1 style="text-align: center; width: 100%; padding-top: 20px;">
    Конвертирайте вашата валута
  </h1>
  <p style="text-align: center; width: 100%;">Използвайте валутния конвертор, за да преобразувате вашата валута
    с днешен курс и я въведете при вашите трансакции.</p>
  <div class="container mt-3">
    <div class="col-md-6 offset-md-3">
      <div class="card">
        <div class="card-header bg-primary text-white">
          <h4 class="mb-0">MYLEV - Валутен конвертор</h4>
        </div>
        <div class="card-body">
          <form>
            <div class="form-group">
              <label for="amount">Количество</label>
              <input type="number" class="form-control" id="amount" [(ngModel)]="amount"
                [ngModelOptions]="{standalone: true}" placeholder="Enter amount">
            </div>
            <div class="form-group">
              <label for="targetCurrency">От валута</label>
              <select class="form-control" id="targetCurrency" [(ngModel)]="targetCurrency"
                [ngModelOptions]="{standalone: true}">
                <option *ngFor="let currency of currencies" [value]="currency">{{currency}}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="baseCurrency">Към валута</label>
              <select class="form-control" id="baseCurrency" [(ngModel)]="baseCurrency"
                [ngModelOptions]="{standalone: true}">
                <option *ngFor="let currency of currencies" [value]="currency">{{currency}}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="result">Резултат</label>
              <input type="number" class="form-control" id="result" value="{{result}}" disabled>
            </div>
            <button type="button" class="btn btn-primary btn-block" (click)="convert()">ПРЕСМЕТНИ</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-calculator></app-calculator>

<footer>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h3>За нас</h3>
        <p>Ние от MYLEV сме екип от професионалисти в областта на финансите, които вярват, че всеки заслужава да има
          контрол върху своите финанси. С нашата приложна програма може да проследите разходите си, да получите подробна
          информация за финансовото си състояние и да управлявате сметките си докато сте в движение.</p>
      </div>
      <div class="col-md-3">
        <h3>За връзка</h3>
        <ul>
          <li>Димитър Найденов 100</li>
          <li>Велико Търново, България</li>
          <li>Email: info@mylev.com</li>
        </ul>
      </div>
      <div class="col-md-3">
        <h3>Последвайте ни в</h3>
        <ul>
          <li><a href="#">Facebook</a></li>
          <li><a href="#">Twitter</a></li>
          <li><a href="#">Instagram</a></li>
          <li><a href="#">LinkedIn</a></li>
        </ul>
      </div>
    </div>
    <hr>
    <p>Изработено от <a href="http://temelkov.tk" target="_blank">Станислав Tемелков</a> &copy; MYLEV 2023</p>
  </div>
</footer>